var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-main-aside"},[_c('div',{staticClass:"layout-main-container"},[_vm._t("main")],2),_c('div',{staticClass:"layout-aside-container"},[_vm._t("aside")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }